import React, { useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View, TextInput } from 'react-native';
import { Auth } from 'aws-amplify';
import * as CmnUtil from '../../components/CmnUtil';
import * as AppConst from '../../components/AppConst';

/** ================================
*  パスワード変更画面
*  ================================*/
const ChangePassword = () => {
  // 各種情報
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // パスワード変更
  const changePassword = async () => {
    // エラーチェック
    if (oldPassword.length == 0) {
      CmnUtil.appAlert('現在のパスワードは必須入力です。');
      return;
    }
    if (newPassword.length == 0) {
      CmnUtil.appAlert('新しいパスワードは必須入力です。');
      return;
    }
    if (confirmPassword.length == 0) {
      CmnUtil.appAlert('新しいパスワード（確認）は必須入力です。');
      return;
    }
    if (newPassword != confirmPassword) {
      CmnUtil.appAlert('新しいパスワードと新しいパスワード（確認）が不一致です。');
      return;
    }

    // パスワード変更
    const user = await Auth.currentAuthenticatedUser();
    try {
      await Auth.changePassword(user, oldPassword, newPassword);
      CmnUtil.appMsg('パスワード変更成功');
      // 入力欄初期化
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err: any) {
      console.log(err);
      switch (err.code) {
        case 'NotAuthorizedException':
          // oldPassword が誤っている場合に起こる。
          CmnUtil.appAlert('現在のパスワードが不一致です。');
          break;
        case 'LimitExceededException':
          // oldPassword を間違え続けた場合に起こる。
          CmnUtil.appAlert('現在のパスワードが不一致です。しばらく経った後に再度お試しください。');
          break;
        case 'InvalidPasswordException':
          // ユーザープールのポリシーで設定したパスワードの強度を満たさない場合に起こる。
          CmnUtil.appAlert('新しいパスワードの強度を満たしていません。');
          break;
        case 'InvalidParameterException':
          // password が6文字未満など Cognito 側で正しくパースできない場合（バリデーションエラー）に起こる。
          CmnUtil.appAlert('新しいパスワードの強度を満たしていません。');
          break;
        default:
          // その他のエラー
          CmnUtil.appAlert('パスワード変更失敗');
      }
    }
  }

  return (
    <View style={styles.container}>
      <View style={styles.box}>
        <Text>現在のパスワード</Text>
        <TextInput
          style={styles.textInput}
          value={oldPassword}
          onChangeText={setOldPassword}
          secureTextEntry={true}
          textContentType='password'
          autoCapitalize='none'
        />
      </View>

      <View style={styles.box}>
        <Text>新しいパスワード</Text>
        <TextInput
          style={styles.textInput}
          value={newPassword}
          onChangeText={setNewPassword}
          secureTextEntry={true}
          textContentType='password'
          autoCapitalize='none'
        />
      </View>

      <View style={styles.box}>
        <Text>新しいパスワード（確認）</Text>
        <TextInput
          style={styles.textInput}
          value={confirmPassword}
          onChangeText={setConfirmPassword}
          secureTextEntry={true}
          textContentType='password'
          autoCapitalize='none'
        />
      </View>

      <TouchableOpacity style={styles.resetButton} onPress={changePassword}>
        <Text style={{ color: AppConst.defaultTextColor }}>パスワード変更</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
  },
  box: {
    marginTop: 10,
  },
  textInput: {
    borderBottomWidth: 1,
    backgroundColor: AppConst.defaultBaseInputColor,
    height: 30,
    paddingLeft: 5,
  },
  resetButton: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: AppConst.defaultColor,
    height: 30,
    marginTop: 30,
    marginBottom: 20,
  },
});

export default ChangePassword;
